import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getMe, login as loginApi, logout as logoutApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMe()
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []); // getMe is a stable module-level import

  const login = useCallback(async (email, password) => {
    const res = await loginApi(email, password);
    setUser(res.data);
    return res.data;
  }, []);

  const logout = useCallback(async () => {
    await logoutApi();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
